<template>
  <div v-if="value!==undefined">
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="예약 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="신청 번호">{{ value.order_num }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="신청 일자">{{ value.created_time }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="신청자">{{ value.name }}</admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="예약자 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="신청자명(ID)">{{ value.name }}({{ value.email }})</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="이메일">{{ value.email }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="휴대전화">{{ value.phone }}</admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full">
        <div class="box">
          <admin-box-item title="신청 상품 정보">
            <table class="reservation-table">
              <thead>
              <tr>
                <th style="width:25%">예약상품</th>
                <th style="width:5%">수량</th>
                <th style="width:15%">이용 일정</th>
                <th style="width:15%">금액</th>
                <th style="width:30%">이용 상태</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <div class="flex align-center">
                    <img :src="value.product.img" style="width:35px;height:35px;margin-right:6px" v-if="value.product.img">
                    <div>{{ value.product.name }}</div>
                  </div>
                </td>
                <td>{{ value.ordered_count }}</td>
                <td>{{ value.resv_date }} {{ value.all_time ? '[종일]' : value.start_time.substring(0,5) }}</td>
                <!--<td style="width:10%">{{ value.total_price | currency }}</td>-->
                <td>{{ value.order_price| currency }}</td>
                <td>{{ value.approval_type_kor }}</td>
              </tr>
              </tbody>
            </table>

            <admin-form-item label="신청확인" style="margin-top:20px">
              <button class="button request-status" @click="clickAccept" v-if="value.status===0">확인하기</button>
              <button style="margin-left:8px" class="button is-danger" @click="clickDeny" v-if="value.status===0">거절하기</button>
              <div v-if="value.status===101">
                <div>신청거절완료</div>
                <div>{{ value.deny_time }}</div>
              </div>
              <div v-if="value.status>=1">신청확인</div>
              <div v-if="value.status>=1">{{ value.request_time }}</div>
            </admin-form-item>

            <admin-form-item label="입금확인">
              <!-- 입금 확인 -->
              <button class="button" @click="clickDeposit" v-if="value.status===1">입금확인하기</button>
              <div v-if="value.status>2">입금완료</div>
              <div v-if="value.deposit_time">{{ value.deposit_time }}</div>
            </admin-form-item>

            <admin-form-item label="승인여부" v-if="value.status!==101">
              <div v-if="value.status===2">
                <button class="button meet-status" @click="clickMeet('approve')">승인</button>
                <button class="button" @click="clickMeet('approve_cancel')">미승인</button>
              </div>
              <div v-if="value.approve_time">
                <div>승인완료</div>
                <div>{{ value.approve_time }}</div>
              </div>
              <div v-if="value.approve_cancel_time">
                <div>승인취소</div>
                <div>{{ value.approve_cancel_time }}</div>
              </div>

              <!-- 승인 여부 -->
             <!-- <button class="button meet-status" @click="clickMeet(2)">승인</button>
              <button class="button" @click="clickMeet(1)">미승인</button>
              <div>{{ value.meet_time }}</div>-->
            </admin-form-item>

            <!--<admin-form-item label="주문현황" v-if="value.status>1">
              &lt;!&ndash; 주문 현황 &ndash;&gt;
              <div v-if="value.approval_type===2">주문완료</div>
              <div v-if="value.approval_type===1">주문취소</div>
              <div>{{ value.meet_time }}</div>
            </admin-form-item>-->

            <admin-form-item label="환불" v-if="value.status!==101">
              <div v-if="value.status===103">
              <!-- 환불 -->
                <button class="button" @click="clickRefund">환불</button>
                <button style="margin-left:8px" class="button is-danger" @click.stop.prevent="clickNoRefund">환불없음</button>
              </div>
              <div v-if="value.status===104">환불완료</div>
              <div v-else-if="value.status===105">환불없음</div>
              <div v-if="value.refund_time">{{ value.refund_time }}</div>
            </admin-form-item>

            <admin-form-item label="취소" v-if="isCard">
              <!-- 환불 -->
              <button class="button half is-danger" v-if="value.status!==102" @click="clickCancel">취소</button>
              <div v-if="value.status===102">취소완료</div>
            </admin-form-item>

<!--
            &lt;!&ndash; 이용상태 변경 &ndash;&gt;
            <div class="flex justify-center status-change-div"
                 v-if="showStatusChangeDiv">
              &lt;!&ndash; 결제완료, 승인대기 &ndash;&gt;
              <button class="button is-primary"
                      style="margin-right:8px"
                      @click="openOrderStatusModal(200, '예약 확정')"
                      v-if="value.status===100">예약 확정</button>
              &lt;!&ndash; 결제완료, 예약확정 &ndash;&gt;
              <button class="button is-primary"
                      style="margin-right:8px"
                      @click="openOrderStatusModal(300, '이용 완료')"
                      v-if="value.status===200">이용 완료</button>
              &lt;!&ndash; 결제완료, 취소완료(예약자 취소) 또는 취소완료(관리자 취소)&ndash;&gt;
              <button class="button"
                      style="margin-right:8px"
                      @click="openOrderStatusModal(402, '예약 취소')"
                      v-if="!(value.status===300 || value.status===401 || value.status===402)">예약 취소</button>
              &lt;!&ndash; 결제완료, 예약확정 &ndash;&gt;
              <button class="button"
                      @click="openOrderStatusModal(500, '노쇼 처리')"
                      v-if="value.status===200">노쇼</button>
              &lt;!&ndash; 예약 취소 &ndash;&gt;
              <div class="negative-div" v-if="value.status===400">
                <i class="material-icons" style="font-size:19px; margin-right:8px">warning</i>
                <span>예약자가 예약을 취소하였습니다.취소/환불 정책에 따라 결제 취소 처리해 주시기 바랍니다.</span></div>
            </div>
            -->
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full">
        <div class="box">
          <admin-box-item title="결제 정보">
            <div class="columns is-multiline">
              <div class="column is-4">
                <table class="reservation-info">
                  <tbody>
                  <tr>
                    <td class="order-info-title">총 주문 금액</td>
                    <td>{{ value.order_price | currency }}</td>
                  </tr>
                  <tr>
                    <td class="order-info-title">할인 금액</td>
                    <td>{{ value.discount_price | currency }}</td>
                  </tr>
                  <tr>
                    <td class="order-info-title">실 결제 금액</td>
                    <td>{{ value.total_price | currency }}</td>
                  </tr>
                  <!--<tr v-if="isCard">
                    <td class="order-info-title">부분 취소 금액</td>
                    <td>{{ value.cancel_price | currency }}</td>
                  </tr>-->
                  </tbody>
                </table>
              </div>
              <div class="column is-8">
                <table class="reservation-info">
                  <tbody>
                  <tr>
                    <td class="order-info-title">결제 수단</td>
                    <td>{{ value.pay_type_kor }}</td>
                  </tr>
                  <!-- 카드 결제 -->
                  <tr v-if="value.pay_type===0">
                    <td class="order-info-title">결제 카드 정보</td>
                    <td>
                      카드사:
                      <span v-if="value.pg_result.CARD_PurchaseName">{{ value.pg_result.CARD_PurchaseName }}</span>
                      <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_CARD_PURCHASE_NAME }}</span>
                      <br>
                      TID:
                      <span v-if="value.pg_result.tid">{{ value.pg_result.tid }}</span>
                      <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_TID }}</span>
                    </td>
                  </tr>
                  <tr v-if="value.pay_type===0">
                    <td class="order-info-title">카드 결제 상세 내역</td>
                    <td>카드결제: {{ payDate }} /
                      <span v-if="value.pg_result.TotPrice">{{ value.pg_result.TotPrice | currency }}</span>
                      <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_AMT | currency }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="order-info-title">결제(입금자)</td>
                    <td>{{ value.name }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <!-- 결제 상태 변경 -->
              <div class="flex justify-center status-change-div" v-if="showPayStatusChangeDiv">
                <div v-if="value.pay_status===100">
                  <button class="button" @click="confirmDeposit">입금 확인</button>
                </div>
                <div v-else-if="value.pay_status>100">
                  <span class="select" style="margin-right:8px">
                    <select v-model="cancel_status" @change="e => cancel_status = parseInt(e.target.value)">
                      <option :value="0" disabled selected>결제 취소 옵션</option>
                      <option :value="item.value"
                              v-for="(item, idx) in cancel_status_arr"
                              :key="'status-'+idx">{{ item.label }}</option>
                    </select>
                  </span>
                  <!-- 부분취소 금액 입력 -->
                  <input class="input full has-text-right"
                         style="margin-left: 8px; width:250px"
                         v-model="cancel_price"
                         @input="e=> cancel_price = parseInt(e.target.value)"
                         v-if="cancel_status===101"
                         type="number">
                  <button class="button" @click="savePayStatus" v-if="value.pay_status>0">적용</button>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <!--&lt;!&ndash; 메모 &ndash;&gt;-->
      <!--<div class="column is-full" v-if="$route.query.id">-->
        <!--<div class="box">-->

          <!--<admin-box-item title="메모">-->
            <!--<div class="columns is-multiline">-->
              <!--<div class="column is-full" v-if="value.memo">-->
                <!--<admin-form-item label="예약자 요청사항">-->
                  <!--{{ value.memo }}-->
                <!--</admin-form-item>-->
              <!--</div>-->
              <!--<div class="column is-full">-->
                <!--<admin-form-item label="관리자용 로그 및 메모">-->
                  <!--<admin-log-memo :memoLogsValue.sync="memo_logs"-->
                                  <!--:newMemoValue.sync="newMemo"-->
                                  <!--placeholder="예약의 간단메모를 입력하는 곳 입니다."-->
                                  <!--@onClickHistoryBtn="res => clickHistoryBtn(res)">-->
                  <!--</admin-log-memo>-->
                <!--</admin-form-item>-->
              <!--</div>-->
            <!--</div>-->
          <!--</admin-box-item>-->
        <!--</div>-->
      <!--</div>-->

    </div>

    <!--saveOrderStatus-->
    <!-- 이용 상태 변경 -->
    <modal name="orderStatusModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <admin-box-item :title="title" :useTab="false" class="lp-modal-wrapper">
        <div><span v-if="title">{{ title }}</span> 하시겠습니까?</div>
        <div v-if="order_status===401 || order_status===402">* 결제 금액에 대한 취소는 결제 정보에서 처리해 주시기 바랍니다.</div>
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveOrderStatus">확인</button>
        </div>
      </admin-box-item>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../module/common/LpCheckBool";
  import moment from 'moment';
  import AdminLogMemo from '../../module/common/AdminLogMemo'
  import AdminFormItem from "../../module/admin/AdminFormItem";

  export default {
    components: {
      AdminFormItem,
      LpCheckBool,AdminLogMemo},
    name: "MeetRequestDetail",
    data() {
      return {
        value: undefined,
        // 부분 취소할 금액
        cancel_price: 0,
        // 메모
        memo_logs: [],
        newMemo: '',
        // 이용 상태
        order_status: 0,
        title: '',
        // 취소 상태
        cancel_status: 0,
        // 취소 옵션
        cancel_status_arr: []
      }
    },
    created() {
      this.getData();
    },
    computed: {
      requiredOptionQuantity () {
        if(!this.value.option_data) return;
        let q = 1;
        let option1 = this.value.option_data.option1[0]
        for(let i=0; i<option1.length; i++) {
          q = option1[i].quantity;
          break;
        }
        return q;
      },
      requiredOptionPrice () {
        if(!this.value.option_data) return;
        let total = 0;
        this.value.option_data.option1.forEach(option => {
          option.forEach(op => {
            total += op.price;
          })
        })
        return total * this.requiredOptionQuantity;
      },
      // 결제 상태 변경 버튼 영역 노출
      showPayStatusChangeDiv () {
        // 환불가능 or 환불완료 상태가 아닐때
        if(this.value.is_cancel_all) return false;
        if(this.isCard) {
          if (this.value.pay_status === 201)
            return false;
          else
            return this.value.pay_status !== 103;
        }
        else return false;
      },
      // 예약 상태 변경 버튼 영역 노출
      showStatusChangeDiv () {

        return [300, 401, 402, 403].indexOf(this.value.status) === -1;
      },
      // 카드 결제 유무
      isCard() {
        return this.value.pay_type === 0 || this.value.pay_type===3;
      },
      payDate() {
        let date = '';
        if(this.value.pg_result.applDate) {
          date = `${this.value.pg_result.applDate} ${this.value.pg_result.applTime}`;
          return moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
        else {
          date = this.value.pg_result.P_AUTH_DT
          return date
        }
      },
    },
    methods: {
      clickCancel() {
        this.$axios.post(this.getUrl(`meet/request/${this.value.id}/cancel`)).then(res=> {
          if(res.status===200) {
            this.value.status=102;
          }
        })
      },

      clickDeny() {
        this.$axios.post(this.getUrl(`meet/request/${this.value.id}/deny`)).then(res=> {
          if(res.status===200) {
            this.value.status = 101;
            this.value.deny_time = moment().format('YYYY-MM-DD HH:mm');
          }
        })
      },

      // 신청 확인하기
      clickAccept() {
        this.$axios.post(this.getUrl(`meet/request/${this.value.id}/accept`)).then(res=>{
          if(res.status===200) {
            this.value.status=1;
            this.value.request_time = moment().format('YYYY-MM-DD HH:mm')
          }
        })
      },

      clickNoRefund () {
        this.$axios.post(this.getUrl(`meet/request/${this.value.id}/no_refund`)).then(res=> {
          if(res.status===200) {
            this.value.status=105;
            this.value.refund_time = moment().format('YYYY-MM-DD HH:mm');
          }
        })
      },

      clickRefund() {
        this.$axios.post(this.getUrl(`meet/request/${this.value.id}/refund`)).then(res=> {
          if(res.status===200) {
            this.value.status=104;
            this.value.refund_time = moment().format('YYYY-MM-DD HH:mm');
          }
        })
      },
      clickDeposit() {
        this.$axios.post(this.getUrl(`meet/request/${this.value.id}/deposit`)).then(res=> {
          if(res.status===200) {
            this.value.status=2;
            this.value.deposit_time = moment().format('YYYY-MM-DD HH:mm')
          }
        }).catch(error => {
          if (error.response) {
            this.toast(error.response.data.message);
          }
        })
      },
      // 승인, 미승인 클릭시
      clickMeet(type) {
        let status = 3;
        if(type==='approve_cancel') {
          status = 103;
        }
        this.$axios.post(this.getUrl(`meet/request/${this.value.id}/${type}`)).then(res=>{
          if(res.status===200) {
            this.value.status=status;
            if (type==='approve') {
              this.value.approve_time = moment().format('YYYY-MM-DD HH:mm');
            }
            else {
              this.value.approve_cancel_time = moment().format('YYYY-MM-DD HH:mm');
            }
          }
        })
      },
      // 이용 상태 팝업 열기
      openOrderStatusModal (status, title) {
        this.title = '';
        this.order_status = status;
        this.title = title;
        // 예약 취소 예외처리
        // 예약 취소 요청 상태(400)일 경우 -> 변경할 상태값은 예약자 취소(401)
        if(this.value.status===400) {
          this.order_status = 401
        }
        this.$modal.show('orderStatusModal');
      },
      // 이용 상태 저장
      saveOrderStatus () {
        if(this.order_status===0) {
          this.toast('변경할 이용상태를 선택하세요');
          return;
        }
        this.$axios.post(this.getUrl('reservation/order/status/change'), {
          id: parseInt(this.$route.query.id),
          status: this.order_status
        }).then(res=> {
          if(res.status===200) {
            this.order_status = 0;
            this.toast('상태가 변경되었습니다.');
            this.$modal.hide('orderStatusModal');
            this.getData();
          }
        }).catch(error => {
          if (error.response) {
            if(error.response.data.message) {
              this.$modal.hide('orderStatusModal');
              this.toast(error.response.data.message);
            }
            else {
              this.$modal.hide('orderStatusModal');
              this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
            }
          }
          else {
            this.$modal.hide('orderStatusModal');
            this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
          }
        })
      },
      // 입금 확인
      confirmDeposit () {
        this.$axios.post(this.getUrl('reservation/order/status/change'), {
          id: parseInt(this.$route.query.id),
          pay_status: 101
        }).then(res=> {
          if(res.status===200) {
            this.toast('상태가 변경되었습니다.');
            this.getData();
          }
        })
      },
      // 결제 상태 저장
      savePayStatus () {
        if(this.cancel_status===0) {
          this.toast('변경할 결제상태를 선택하세요');
          return;
        }
        let params = {
          id: parseInt(this.$route.query.id),
          cancel_status: this.cancel_status
        }
        // 부분 취소 예외처리
        if(this.cancel_status===101) {
          if(this.cancel_price===0) {
            this.toast('부분 취소할 금액을 입력하세요.');
            return;
          }
          else {
            params['cancel_price'] = this.cancel_price;
          }
        }
        this.$axios.post(this.getUrl('reservation/order/status/change'), params).then(res=> {
          if(res.status===200) {
            this.cancel_status = 0;
            this.toast('상태가 변경되었습니다.')
            this.getData();
          }
        })
      },
      // 관리자 메모 작성
      clickHistoryBtn (memo) {
        let authorName = this.$store.state.auth.admin.username;
        this.$axios.post(this.getUrl('reservation/order/' + this.$route.query.id + '/memo'), {
          author: authorName,
          content: memo
        }).then(res => {
          if (res.status === 200) {
            let now = moment().format('YYYY-MM-DD HH:mm');
            this.memo_logs.splice(0, 0, {
              created_time: now,
              author: authorName,
              content: memo
            });
            this.newMemo = '';
            this.toast('로그가 저장되었습니다.');
          }
        });
      },
      getData() {
        this.$axios.get(this.getUrl(`meet/request/${this.$route.query.id}`)).then(res=> {
          this.value = res.data;
          if(this.isCard) {
            /*let status = find(this.status_arr, 'value', 504);
            if(status===undefined) this.status_arr.push({label:'취소완료(환불완료)',value:504});*/
            this.cancel_status_arr = [
              {label:'카드 전체 취소',value:100},
              {label:'카드 부분 취소',value:101},
              {label:'환불 없음',value:201},
            ];
          }
          else {
            this.cancel_status_arr = [
              {label:'환불 완료',value:200},
              {label:'환불 없음',value:201},
            ];
          }
        })
      },
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .reservation-table
    border 1px solid #d8d8d8
    border-collapse collapse
    width 100%

  .reservation-info
    width 100%

  .reservation-table th
    background-color #eee
    border 1px solid #d8d8d8
    color #363636

  .reservation-table td
    vertical-align middle

  .reservation-table th
  .reservation-table td
    border 1px solid #d8d8d8
    padding 4px
    text-align center
  .reservation-info td
    text-align center
    border 1px solid #e0d9d9
    padding 6px
    vertical-align middle !important

  .reservation-info .order-info-title
    color #363636
    background-color #eee
    font-weight bold

  .status-change-div
    width 100%
    margin-top 12px
    background-color #eee
    padding 8px 0

  .negative-div
    display flex
    align-items center
    color $negative

  .meet-status
    background-color $primary
    color white
</style>
